import { QueryClient } from '@tanstack/react-query';
import { PortfolioBase } from '@unistocks/features/portfolios/models/portfolio-base';
import { WATCHLIST } from '@unistocks/features/portfolios/portfolio-type';
import { WatchlistDto } from '@unistocks/proxy/axios-client';
import {
  watchlistsGetListQueryKey,
  watchlistsGetQueryKey
} from '@unistocks/proxy/axios-client/WatchlistsQuery';

export const isWatchlist = (portfolio: PortfolioBase): portfolio is WatchlistDto => {
  return portfolio?.type === WATCHLIST;
};

export const invalidateWatchlistQueriesById = (queryClient: QueryClient, id: string) => {
  // Invalidate watchlist
  queryClient.invalidateQueries({ queryKey: watchlistsGetQueryKey(id) });
  // Invalidate watchlist list
  queryClient.invalidateQueries({ queryKey: watchlistsGetListQueryKey() });
};
